import colors from 'vuetify/lib/util/colors'

export const theme = {
  themes: {
    light: {
      textBlack: '#404040',
      textGrey: '#616161',
    },
    dark: {
      textBlack: colors.white,
      textGrey: colors.white,
    },
  },
}
